import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractFilterComponent} from '../abstract-filter.component';
import {SelectItem} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-simple-list-col-etl',
    templateUrl: './simple-list-col-etl.component.html',
    styleUrls: ['./simple-list-col-etl.component.scss'],
    standalone: false
})
export class SimpleListColEtlComponent extends AbstractFilterComponent implements OnInit {

    @Output() valueChange = new EventEmitter<string>();
    @Input() value: string;

    constructor() {
        super();
        this.defaultEmptyValue = false;
    }

    ngOnInit(): void {
        this.updateListCol();
    }


    protected handlerLoadEachItem(item: SelectItem) {
        if (item.value === this.value) {
            this.itemCol = item.value;
            this.update();
        }
    }

    update($event?) {
        this.updateExampleData(this.itemCol);
        this.valueChange.emit(this.itemCol);
    }
}
